export default function createReferenceNumber(prefix, date) {
  return prefix +  Math.floor(date/1000) + Math.random().toString().slice(-4)
}

